import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/portal/deal-summary — pre-aggregated dashboard metrics so the page
// doesn't pull raw attribution rows just to count them. introCount is the
// "Bookboost referred to you" callout; the other four feed the three top-of-
// dashboard MetricCards (Wins includes wonValueEur as its hint).
export type PartnerDealSummary = {
  myDeals: number;
  activeDeals: number;
  wonDeals: number;
  wonValueEur: number;
  introCount: number;
};

export function usePartnerDealSummary() {
  return useQuery<PartnerDealSummary, ApiClientError>({
    queryKey: queryKeys.portal.dealSummary(),
    queryFn: () => apiFetch<PartnerDealSummary>("/portal/deal-summary"),
  });
}
